import { render, staticRenderFns } from "./Quickscan.vue?vue&type=template&id=4de123c6"
import script from "./Quickscan.vue?vue&type=script&lang=js"
export * from "./Quickscan.vue?vue&type=script&lang=js"
import style0 from "./Quickscan.vue?vue&type=style&index=0&id=4de123c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports